/**
 * Baloot in words, the three languages side by side (review 0027 B6): a game's strings live in the
 * game's own file, as Hearts' and King's do, so the language files stay in budget as games arrive.
 */
export const balootEn = {
  "baloot.handEnd.made": "{name} played {call} and made it",
  "baloot.handEnd.failed": "{name} played {call} and went down",
  "baloot.call.title": "Your call",
  "baloot.call.turned": "Turned",
  "baloot.call.round": "Round {round}",
  "baloot.call.standing": "Hokum {suit} on the table",
  "baloot.call.hokum": "Hokum",
  "baloot.call.sun": "Sun",
  "baloot.call.noTrump": "no trump",
  "baloot.call.note.1": "Hokum: the turned suit is trump · Sun: no trump",
  "baloot.call.note.2": "Second round: name another suit, or Sun",
  "baloot.call.note.over": "Only Sun goes over a Hokum on the table",
  "baloot.double.note": "Points count ×{times} this hand",
  "baloot.double.top": "The stake is at the top",
  "baloot.bar.mode": "Mode",
  "baloot.event.contract-won": "{name} plays {call}",
  "baloot.event.kaboot": "Kaboot! Every trick",
  "baloot.event.baloot": "{name} holds the baloot",
  "baloot.double.title": "Double?",
  "baloot.double.1": "Plain",
  "baloot.double.2": "Double",
  "baloot.double.3": "Three",
  "baloot.double.4": "Four",
  "baloot.double.5": "Gahwa",
  "baloot.project.sira": "Sira",
  "baloot.project.fifty": "50",
  "baloot.project.hundred": "100",
  "baloot.project.fourHundred": "400",
  "baloot.event.doubled": "{level}! Winner takes all",
  "baloot.event.project": "{name}: {project}",
} as const;

type BalootKey = keyof typeof balootEn;

export const balootTr: Record<BalootKey, string> = {
  "baloot.handEnd.made": "{name} {call} oynadı, tuttu",
  "baloot.handEnd.failed": "{name} {call} oynadı, battı",
  "baloot.call.title": "Kararın",
  "baloot.call.turned": "Açık kart",
  "baloot.call.round": "{round}. tur",
  "baloot.call.standing": "Masada Hokum {suit}",
  "baloot.call.hokum": "Hokum",
  "baloot.call.sun": "Sun",
  "baloot.call.noTrump": "kozsuz",
  "baloot.call.note.1": "Hokum: koz açık kartın rengi · Sun: kozsuz",
  "baloot.call.note.2": "İkinci tur: başka bir renk ya da Sun",
  "baloot.call.note.over": "Masadaki Hokum'u yalnız Sun geçer",
  "baloot.double.note": "Bu elde puanlar ×{times}",
  "baloot.double.top": "Katsayı en üstte",
  "baloot.bar.mode": "Mod",
  "baloot.event.contract-won": "{name} {call} oynuyor",
  "baloot.event.kaboot": "Kaboot! Bütün eller",
  "baloot.event.baloot": "{name} baloot tutuyor",
  "baloot.double.title": "Double?",
  "baloot.double.1": "Düz",
  "baloot.double.2": "Double",
  "baloot.double.3": "Three",
  "baloot.double.4": "Four",
  "baloot.double.5": "Gahwa",
  "baloot.project.sira": "Sira",
  "baloot.project.fifty": "50",
  "baloot.project.hundred": "100",
  "baloot.project.fourHundred": "400",
  "baloot.event.doubled": "{level}! Kazanan hepsini alır",
  "baloot.event.project": "{name}: {project}",
};

export const balootAr: Record<BalootKey, string> = {
  "baloot.handEnd.made": "{name} لعب {call} وجابها",
  "baloot.handEnd.failed": "{name} لعب {call} وخسر",
  "baloot.call.title": "اختيارك",
  "baloot.call.turned": "المكشوفة",
  "baloot.call.round": "الدور {round}",
  "baloot.call.standing": "حكم {suit} على الطاولة",
  "baloot.call.hokum": "حكم",
  "baloot.call.sun": "صن",
  "baloot.call.noTrump": "بدون حكم",
  "baloot.call.note.1": "حكم: نوع الورقة المكشوفة هو الحكم · صن: بدون حكم",
  "baloot.call.note.2": "الدور الثاني: اختر نوعًا آخر أو صن",
  "baloot.call.note.over": "فقط الصن يعلو على حكم موجود على الطاولة",
  "baloot.double.note": "النقاط ×{times} في هذه الجولة",
  "baloot.double.top": "الرهان في أعلى مستوى",
  "baloot.bar.mode": "النوع",
  "baloot.event.contract-won": "{name} يلعب {call}",
  "baloot.event.kaboot": "كبوت! كل الأكلات",
  "baloot.event.baloot": "{name} معه البلوت",
  "baloot.double.title": "دبل؟",
  "baloot.double.1": "عادي",
  "baloot.double.2": "دبل",
  "baloot.double.3": "ثري",
  "baloot.double.4": "فور",
  "baloot.double.5": "قهوة",
  "baloot.project.sira": "سرا",
  "baloot.project.fifty": "50",
  "baloot.project.hundred": "100",
  "baloot.project.fourHundred": "400",
  "baloot.event.doubled": "{level}! الفائز يأخذ كل شيء",
  "baloot.event.project": "{name}: {project}",
};
